/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Menufilepdftoolarge4Inputs */

const en_menufilepdftoolarge4 = /** @type {(inputs: Menufilepdftoolarge4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is too large: PDFs up to 15 MB.`)
};

const de_menufilepdftoolarge4 = /** @type {(inputs: Menufilepdftoolarge4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ist zu groß: PDFs bis 15 MB.`)
};

/**
* | output |
* | --- |
* | "{name} is too large: PDFs up to 15 MB." |
*
* @param {Menufilepdftoolarge4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menufilepdftoolarge4 = /** @type {((inputs: Menufilepdftoolarge4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menufilepdftoolarge4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menufilepdftoolarge4(inputs)
	return de_menufilepdftoolarge4(inputs)
});
export { menufilepdftoolarge4 as "menuFilePdfTooLarge" }